import React from 'react'

export const FonteLiberacaoEnum = {
  CENTRAL_CADASTROS: 'CENTRAL_CADASTROS',
  GESTOR: 'GESTOR',
  AUTOMATICAMENTE: 'AUTOMATICAMENTE',
  NAO_RECOMENDAR: 'NAO_RECOMENDAR'
}

export const FonteLiberacaoLabelEnum = {
  CENTRAL_CADASTROS: 'Central de Cadastros',
  GESTOR: 'Gestor',
  AUTOMATICAMENTE: 'Automaticamente',
  NAO_RECOMENDAR: 'Não Recomendar'
}

export const FonteLiberacaoAbrev = {
  [FonteLiberacaoEnum.CENTRAL_CADASTROS]: 'C. C',
  [FonteLiberacaoEnum.GESTOR]: 'A. G',
  [FonteLiberacaoEnum.AUTOMATICAMENTE]: 'AUT',
  [FonteLiberacaoEnum.NAO_RECOMENDAR]: 'N. R'
}

export const FonteLiberacaoColors = {
  CENTRAL_CADASTROS: '#81C784',
  GESTOR: '#64B5F6',
  AUTOMATICAMENTE: '#80CBC4',
  NAO_RECOMENDAR: '#9fa8da'
}

export function BadgeFonteLiberacao({ fonteLiberacao }) {
  return (
    <div
      style={{
        padding: 10,
        borderRadius: 10,
        boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
        backgroundColor: FonteLiberacaoColors[fonteLiberacao] || '#ededed',
        textAlign: 'center',
        lineHeight: '100%'
      }}
    >
      {FonteLiberacaoAbrev[fonteLiberacao] || 'N/A'}
    </div>
  )
}
